import { faCaretRight } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { Link } from '@sorare/routing';

import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LinkBox, LinkOverlay } from '@sorare/core/src/atoms/navigation/Box';
import { LabelL, LabelS } from '@sorare/core/src/atoms/typography';
import { Countdown } from '@sorare/core/src/components/Countdown';
import { ANY_SPORT_PLAY_ADVENT_CALENDAR } from '@sorare/core/src/constants/__generated__/routes';
import { useCurrentSport } from '@sorare/core/src/hooks/useCurrentSport';
import useFeatureFlags from '@sorare/core/src/hooks/useFeatureFlags';
import { generateSportPath } from '@sorare/core/src/lib/routing/generateSportPath';

import { Logo } from '../Logo';
import { NeonChristmasBackground } from '../NeonChristmasBackground';
import { NEON_CHRISTMAS_START_DATE } from '../event';

const Wrapper = styled(LinkBox)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  padding: var(--quadruple-unit) var(--quadruple-unit) var(--quadruple-unit)
    var(--double-unit);

  position: relative;
`;

const StyledLabelS = styled(LabelS)`
  color: var(--c-nd-600);
`;

export const NeonChristmasMarketplaceBanner = () => {
  const {
    flags: { useNeonChristmas = false },
  } = useFeatureFlags();
  const sport = useCurrentSport();

  if (!useNeonChristmas) {
    return null;
  }

  return (
    <Wrapper>
      <NeonChristmasBackground
        style={
          {
            backgroundImage: `linear-gradient(
              to right,
              rgba(255, 43, 43, 0.2) 0%,
              rgba(16, 16, 16, 0.2) 100%`,
            position: 'absolute',
            inset: 0,
            zIndex: -1,
          } as React.CSSProperties
        }
      />
      <Logo />

      <Horizontal center gap={4}>
        <Countdown
          date={NEON_CHRISTMAS_START_DATE}
          Label={LabelL}
          gap={4}
          Caption={StyledLabelS}
        />
        <LinkOverlay
          as={Link}
          to={generateSportPath(ANY_SPORT_PLAY_ADVENT_CALENDAR, { sport })}
        >
          <FontAwesomeIcon icon={faCaretRight} />
        </LinkOverlay>
      </Horizontal>
    </Wrapper>
  );
};
